// extracted by mini-css-extract-plugin
export var container = "styles-module__container___AJJ8s";
export var text = "styles-module__text___PeErg";
export var iconImage = "styles-module__iconImage___Gq0vd";